import * as __SNOWPACK_ENV__ from '../../_snowpack/env.js';

/**
 * REST DATA SearchOptions
 */
export const getSearchOptions = async (params) => {
	const url = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_REST_ROUTE + 'v2/search/options/';
	const res = await fetch(url, {
		method: 'POST',
		credentials: 'omit',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(params)
	});
	return await res.json();
};

/**
 * REST DATA SearchResult
 */
export const getSearchResult = async (params) => {
	const url = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_REST_ROUTE + 'v2/search/result/';
	const res = await fetch(url, {
		method: 'POST',
		credentials: 'omit',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(params)
	});
	return await res.json();
};

/**
 * REST DATA SearchExcerptList
 */
export const getSearchExcerptList = async (params) => {
	params.elimit = '15';
	const url =
		__SNOWPACK_ENV__.SNOWPACK_PUBLIC_REST_ROUTE + 'v2/search/excerptlist/';
	const res = await fetch(url, {
		method: 'POST',
		credentials: 'omit',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(params)
	});
	return await res.json();
};
